import { render, staticRenderFns } from "./phone-number-validation-data.vue?vue&type=template&id=5e41f651&scoped=true&"
import script from "./phone-number-validation-data.vue?vue&type=script&lang=js&"
export * from "./phone-number-validation-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41f651",
  null
  
)

export default component.exports